/* Smile — « Le Déclic ». Small, dependency-free. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal: sections snap in once ---- */
  function reveal() {
    var els = $$('[data-sm-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- Lazy muted loops: load + play only on screen ---- */
  function videos() {
    var vids = $$('video[data-sm-video]');
    if (!vids.length) return;
    var load = function (v) { if (!v.src && v.dataset.src) { v.src = v.dataset.src; } };
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { load(v); v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { load(v); if (!reduce) { var p = v.play(); if (p) p.catch(function () {}); } } else { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---- Mobile menu ---- */
  function menu() {
    var btn = $('[data-sm-burger]'), nav = $('[data-sm-nav]');
    if (!btn || !nav) return;
    var veil = document.createElement('div'); veil.className = 'sm-veil'; document.body.appendChild(veil);
    var set = function (on) {
      nav.classList.toggle('is-open', on); veil.classList.toggle('is-on', on);
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      document.documentElement.style.overflow = on ? 'hidden' : '';
    };
    btn.addEventListener('click', function () { set(!nav.classList.contains('is-open')); });
    veil.addEventListener('click', function () { set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* ---- Before / after ---- */
  function beforeAfter() {
    $$('[data-sm-ba]').forEach(function (f) {
      var r = $('[data-sm-ba-range]', f);
      var set = function (v) { f.style.setProperty('--pos', v + '%'); };
      r.addEventListener('input', function () { f.classList.remove('is-hint'); set(r.value); });
      // one hint swipe when it first appears: shows it's draggable
      if (reduce || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        f.classList.add('is-hint');
        setTimeout(function () { set(22); }, 300);
        setTimeout(function () { set(72); }, 1300);
        setTimeout(function () { set(50); r.value = 50; }, 2300);
        setTimeout(function () { f.classList.remove('is-hint'); }, 3300);
      }, { threshold: 0.6 });
      io.observe(f);
    });
  }

  /* ---- Buy blocks: pack cards -> variant id, prices, gallery ---- */
  function buy() {
    $$('[data-sm-buy]').forEach(function (b) {
      var data = [];
      try { data = JSON.parse($('[data-sm-variants]', b).textContent); } catch (e) {}
      var idIn = $('[data-sm-id]', b), btn = $('[data-sm-submit]', b), label = $('[data-sm-label]', b), bp = $('[data-sm-btn-price]', b);
      var buyLabel = label ? label.textContent : '';
      var pdp = b.closest('[data-sm-pdp]');
      $$('[data-sm-pack]', b).forEach(function (r) {
        r.addEventListener('change', function () {
          var v = data.filter(function (x) { return String(x.id) === r.value; })[0];
          if (!v) return;
          $$('.sm-pack', b).forEach(function (l) { l.classList.toggle('is-on', l.contains(r)); });
          idIn.value = v.id;
          if (bp) bp.textContent = v.price;
          btn.disabled = !v.available;
          if (label) label.textContent = v.available ? buyLabel : 'Sold out';
          if (pdp) {
            $$('[data-sm-price] .sm-price__now', pdp).forEach(function (e) { e.textContent = v.price; });
            var sp = $('[data-sm-sticky-price]', pdp); if (sp) sp.textContent = v.price;
            var sn = $('[data-sm-sticky-name]', pdp); if (sn) sn.textContent = r.closest('.sm-pack').querySelector('.sm-pack__name').textContent;
            var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
            if (v.media) goTo(pdp, String(v.media));
          }
        });
      });
      // the button "clips in" then shows it's going
      var form = $('[data-sm-form]', b);
      if (form) form.addEventListener('submit', function () { if (label) label.textContent = 'Heading to checkout…'; btn.classList.add('is-going'); });
    });
  }

  /* ---- Gallery: swipe dots + thumbs ---- */
  function goTo(root, id) {
    var track = $('[data-sm-track]', root);
    var slide = track && $('[data-media-id="' + id + '"]', track);
    if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
  }
  function gallery() {
    $$('[data-sm-gallery]').forEach(function (g) {
      var track = $('[data-sm-track]', g), dots = $$('.sm-gallery__dots i', g), thumbs = $$('[data-sm-thumb]', g);
      if (!track) return;
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
          thumbs.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        }, 60);
      }, { passive: true });
      thumbs.forEach(function (th) { th.addEventListener('click', function () { goTo(g, th.dataset.smThumb); }); });
    });
  }

  /* ---- Sticky buy bar (mobile): on from the first screen whenever the main button is not fully in view ---- */
  function sticky() {
    var bar = $('[data-sm-sticky]');
    var main = bar && $('[data-sm-pdp] .sm-buy__btn');
    if (!bar || !main) return;
    var footer = $('.sm-footer');
    var mainFull = false, footVisible = false;
    var upd = function () { bar.classList.toggle('is-on', !mainFull && !footVisible); };
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }
    new IntersectionObserver(function (es) { mainFull = es[0].intersectionRatio > 0.95; upd(); }, { threshold: [0, 0.95, 1] }).observe(main);
    if (footer) new IntersectionObserver(function (es) { footVisible = es[0].isIntersecting; upd(); }).observe(footer);
    upd();
  }

  /* ---- Review cards carousel: arrows + gentle autoplay (paused on touch/hover) ---- */
  function revs() {
    $$('[data-sm-revs]').forEach(function (r) {
      var t = $('[data-sm-revs-track]', r); if (!t) return;
      var n = t.children.length, timer;
      var go = function (d) { var i = Math.round(t.scrollLeft / t.clientWidth); i = (i + d + n) % n; t.scrollTo({ left: i * t.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); };
      $('[data-sm-revs-prev]', r).addEventListener('click', function () { go(-1); });
      $('[data-sm-revs-next]', r).addEventListener('click', function () { go(1); });
      var play = function () { if (reduce || n < 2) return; clearInterval(timer); timer = setInterval(function () { go(1); }, 5000); };
      ['pointerdown', 'mouseenter', 'focusin'].forEach(function (e) { r.addEventListener(e, function () { clearInterval(timer); }); });
      r.addEventListener('mouseleave', play);
      play();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    reveal(); videos(); menu(); beforeAfter(); buy(); gallery(); sticky(); revs();
    $$('.sm-404__curve').forEach(function (c) { c.classList.add('is-in'); });
  });
})();
